<template>
    <v-dialog v-model="dialogModel" max-width="1100">

        <v-card>

            <toolbar-page icon="mdi-alert-outline" title="Project errors" disable-icon>
                <template slot="buttons">

                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn small color="primary" @click="clearAll()" v-on="on">Clear all</v-btn>
                        </template>
                        Clear all errors
                    </v-tooltip>

                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="closeDialog">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>

                </template>
            </toolbar-page>

            <v-data-table
                :headers="headers"
                :items="errors"
                item-key="name"
                dense
                class="elevation-1"
                :footer-props="{itemsPerPageOptions:[10,25,50,100]}"
            >
                <template v-slot:body="{ items }">

                    <tbody>

                    <tr class="cursor-pointer" v-for="item in items" :key="item.id">
                        <td class="truncate">
                            <v-tooltip color="primary" top open-delay="500" max-width="500">
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        {{ item.message }}
                                    </div>
                                </template>
                                {{ item.message }}
                            </v-tooltip>
                        </td>
                        <td>
                            {{ toHumanFrom(item.created_at) }}
                        </td>
                        <td>
                            <v-tooltip color="primary" top>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="!hasPermission('update projects')"
                                           icon
                                           text
                                           class="ma-0"
                                           v-on="on"
                                           @click="deleteClicked(item)"
                                           color="secondary">
                                        <v-icon light small color="white">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete source</span>
                            </v-tooltip>
                        </td>
                    </tr>

                    </tbody>
                </template>
            </v-data-table>

        </v-card>
    </v-dialog>
</template>

<script>
import ToolbarPage from "../../../components/UI/ToolbarPage";
import {timeDisplay} from "../../../components/mixins/timeDisplayMixin";
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

export default {

    mixins: [timeDisplay],

    name: "ProjectErrorsDialog",

    components: {
        ToolbarPage
    },

    props: {
        value: {
            required: true,
            type: Boolean
        },
        errors: {
            required: true,
            type: Array
        },
        projectId: {
            required: true,
            type: Number,
        }
    },

    computed: {
        dialogModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },

    data() {
        return {
            headers: [
                {
                    text: 'ERROR MESSAGE',
                    align: 'start',
                    sortable: false,
                    value: 'message',
                },
                {text: 'CREATED AT', width: '200px', value: 'created_at'},
                {text: 'DELETE', width: '90px'}
            ],
        }
    },

    methods: {

        ...mapActions('ProjectManager', [
            'deleteProjectErrors',
            'deleteProjectError'
        ]),

        closeDialog() {
            this.$emit('input', false);
        },

        clearAll() {
            this.deleteProjectErrors(this.projectId)
                .then(() => {
                    Bus.$emit('errors-cleared');
                    Bus.$emit('flash-message', {message: 'Project errors successfully cleared'});
                    this.closeDialog();
                })
                .catch(() => {
                    Bus.$emit('flash-message', {type: 'error', message: 'OOPS! Project errors failed to clear!'});
                })
        },

        deleteClicked(error) {
            this.deleteProjectError(error)
                .then(() => {
                    Bus.$emit('errors-cleared');
                    Bus.$emit('flash-message', {message: 'Project error cleared'});
                })
                .catch((error) => {
                    console.log(error);
                    Bus.$emit('flash-message', {type: 'error', message: 'OOPS! Project error failed to clear!'});
                })
        }
    }
}
</script>

<style scoped>

.truncate {
    max-width: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>
